import { getController as getObjectsController } from './DocumentManagement';
import { getMethods as getExplorerMethods } from './DocuSign';
import { getMethods as getSignatureMethods } from './Signature';
import { getMethods as getCertificateMethods } from './Certificate';

const getController = (service: 'dm') => ({
	DocumentManagement: getObjectsController(service),
	DocuSign: getExplorerMethods(service, 'DocuSign'),
	Signature: getSignatureMethods(service, 'Signature'),
	Certificate: getCertificateMethods(service, 'Certificate')
});

export { getController };
